export const MINIMUM_CONTENT_WIDTH = 1200

export const GITHUB_INTEGRATION_REGEX = /https?:\/\/github\.com\/.*?\/.*?\/(?<resourceName>issues|pull)\/\d+/
export const JIRA_INTEGRATION_REGEX =
  /https?:\/\/.*\.atlassian\.net\/((jira\/software\/projects\/([^?]*)\?selectedIssue=)|(browse\/))(?<id>[^?/]+)/
export const AIRTABLE_URL_REGEX = /https?:\/\/airtable\.com\/.*/
export const CANVA_URL_REGEX = /https?:\/\/www\.canva\.com\/.*/
export const CLICKUP_URL_REGEX = /https?:\/\/sharing\.clickup\.com\/.*/
export const FIGMA_URL_REGEX = /https?:\/\/www\.figma\.com\/file\/.*/
export const GOOGLE_DOCS_URL_REGEX = /https?:\/\/docs\.google\.com\/.*/
export const GOOGLE_FORMS_URL_REGEX = /https?:\/\/docs\.google\.com\/forms\/.*/
export const GOOGLE_MAPS_URL_REGEX = /https?:\/\/www\.google\.com\/maps\/.*/
export const GOOGLE_SHEETS_URL_REGEX = /https?:\/\/docs\.google\.com\/spreadsheets\/.*/
export const GOOGLE_SLIDES_URL_REGEX = /https?:\/\/docs\.google\.com\/presentation\/.*/
export const LOOM_URL_REGEX = /https?:\/\/www\.loom\.com\/share\/.*/
export const MIRO_URL_REGEX = /https?:\/\/miro\.com\/.*/
export const TWITTER_URL_REGEX = /https?:\/\/twitter\.com\/.*/
export const VIMEO_URL_REGEX = /https?:\/\/vimeo\.com\/.*/
export const YOUTUBE_URL_REGEX = /https?:\/\/www\.youtube\.com\/watch\?v=.*/

export const INTEGRATION_REGEXES = [
  AIRTABLE_URL_REGEX,
  CANVA_URL_REGEX,
  CLICKUP_URL_REGEX,
  FIGMA_URL_REGEX,
  GOOGLE_DOCS_URL_REGEX,
  GOOGLE_FORMS_URL_REGEX,
  GOOGLE_MAPS_URL_REGEX,
  GOOGLE_SHEETS_URL_REGEX,
  GOOGLE_SLIDES_URL_REGEX,
  LOOM_URL_REGEX,
  MIRO_URL_REGEX,
  TWITTER_URL_REGEX,
  VIMEO_URL_REGEX,
  YOUTUBE_URL_REGEX,
]
